import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import publicHelpers from 'globals/helpers/public-helpers';

@Component({
    selector: 'checks-dialog',
    template: `
<dialog-wrapper
  [backgroundColor]="data.backgroundColor || defaultColor"
  [dialogTitle]="data.title"
  [smallTitle]="true"
  [tiny]="true"
  [disabled]="data.atLeastOne && !checked"
  [showClose]="false"
  [giveMeTwenty]="true"
  [titleHeight]="40"
  (submit)="dialogRef.close(data)"
  cdkDropList
  [cdkDropListData]="data.checkboxes"
  (cdkDropListDropped)="dropCheck($event)"
>
  <div class="instructions" *ngIf="data.instructions" [innerHTML]="helpers.strWithBreak(data.instructions)"></div>
  <div class="check-holder" [ngClass]="{ card: !!data.drag }" *ngFor="let check of data.checkboxes" color="primary" cdkDrag>
    <icon class="handle" *ngIf="data.drag" cdkDragHandle matIcon="drag_indicator"></icon>
    <mat-checkbox (change)="toggleCheck(check)" [checked]="check.checked"></mat-checkbox>
    <div class="title">{{ check.title }}</div>
  </div>
</dialog-wrapper>
`,
    styles: [`
    .instructions { margin-bottom: 15px; }
    .check-holder { display: flex; margin-bottom: 10px; background-color: rgba(255,255,255,0.85); }
    .check-holder.card { padding: 5px; margin-bottom: 5px; border-radius: 6px; border: 1px solid #ddd; }
    mat-checkbox { margin-right: 10px; }
    .handle { color: #999; cursor: pointer; margin-right: 5px; } 
  `],
    styleUrls: ['../../modules/sponsors/rank-select.scss'],
    standalone: true,
    imports: [MatCheckboxModule, IconComponent, CommonModule,DialogWrapperComponent, CdkDropList, CdkDragHandle, CdkDrag]
})
export class CheckDialogComponent {
  defaultColor: string = null
  helpers = publicHelpers
  checked: number = 0

  constructor(
    public dialogRef: MatDialogRef<CheckDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OnlyChecksDialogData,
  ) {
    this.count()
  }

  count() {
    this.checked = this.data.checkboxes.filter(c => c.checked).length
  }

  toggleCheck(check: ICheck) {
    check.checked = !check.checked
    this.count()
  }

  dropCheck(event: CdkDragDrop<ICheck[]>) {
    moveItemInArray(this.data.checkboxes, event.previousIndex, event.currentIndex);
  }
}

export interface ICheck {
  checked: boolean
  id: string
  title: string
}
export interface OnlyChecksDialogData {
  title: string
  instructions: string
  drag?: boolean
  backgroundColor?: string
  atLeastOne: boolean
  checkboxes: ICheck[]
}